import stringToHash, { jsonToHash } from './crypto'
import getUserInfo from './getUserInfo'
import { pushEventDataLayerObj } from './pushEventDataLayer'
import { siteUrl } from '../shared/utils/siteUrl'
/*
copy excel columns
    json={};s.replaceAll("\t","|").replaceAll('|||','').split("\n").filter((str)=>str.trim().length>1).map((str)=>  str.split("|")  ).forEach((arr)=>{  json[arr[0]]={event:arr[1],category:arr[2],action:arr[3]}; })
*/

type TagSetting = Record<string, any>
const TAGS: TagSetting = {
  '6A': {
    event: 'Interacciones_Menú_V-School',
    category: 'Menu principal',
    action: 'click',
  },
  '7A': {
    event: 'Interacciones_Home_V-School',
    category: 'Comenzar Actividad',
    action: 'click',
  },
  '8A': {
    event: 'Interacciones_T&C_V-School',
    category: 'Actividad promocional',
    action: 'view',
  },
  '9A': {
    event: 'Interacciones_FAQ_V-School',
    category: 'Preguntas Frecuentes',
    action: 'click',
  },
  '10A': {
    event: 'Interacciones_Login_V-School',
    category: 'Inicio Sesion',
    action: 'click',
  },
  '11A': {
    event: 'Interacciones_Login_V-School',
    category: 'Inicio Sesion',
    action: 'click',
  },
  '12A': {
    event: 'Interacciones_Login_V-School',
    category: '¡Lo sentimos!',
    action: 'view',
  },
  '13A': {
    event: 'Interacciones_Redencion_V-School',
    category: 'Inscribir claves',
    action: 'click',
  },
  '14A': {
    event: 'Interacciones_Redencion_V-School',
    category: 'Se acabaron tus vidas',
    action: 'click',
  },
  '15A': {
    event: 'Interacciones_Comentarios_V-School',
    category: '¡Cuéntanos tu experiencia!',
    action: 'click',
  },
  '16A': {
    event: 'Interacciones_DoblePuntaje_V-School',
    category: 'Misión Max Cur-V',
    action: 'view',
  },
  '17A': {
    event: 'Interacciones_DoblePuntaje_V-School',
    category: 'Misión Max Cur-V',
    action: 'click',
  },
}

async function getUserData() {
  const userInfo = getUserInfo()

  const logged = userInfo !== null
  const log_status = logged ? 'Yes' : 'Not'
  const user_data = [
    userInfo &&
      (await jsonToHash({
        nombre: userInfo.name,
        apellido: userInfo.lastName,
        celular: userInfo.cellPhone,
        correo: userInfo.email,
        ciudad: userInfo.location?.cityName,
        departamento: userInfo.location?.countryStateName,
        pais: userInfo.countryName,
      })),
  ]
  return {
    user_data,
    log_status,
  }
}
var store_user_data: any = null
async function getLastUserData() {
  if (store_user_data) {
    return store_user_data
  }
  store_user_data = await getUserData()
  return store_user_data
}

export async function triggerTag(tagId: string, custom = {}) {
  if (!TAGS.hasOwnProperty(tagId)) throw `Tag ${tagId} doesnt exist`

  const tagInfo = TAGS[tagId]
  const user = await getLastUserData()
  const location = window ? window.location.href : siteUrl
  pushEventDataLayerObj({ ...tagInfo, ...custom, location, ...user })
}

export async function triggerPageView() {
  if (typeof document === 'undefined') {
    return
  }
  const userInfo = getUserInfo()
  const dataTag = {
    event: 'Page_View',
    title: document.title,
    page: window.location.pathname,
    userId: userInfo ? await stringToHash(userInfo.userId) : undefined,
  }
  pushEventDataLayerObj({ ...dataTag })
}
